import { render, staticRenderFns } from "./CounterVisitor.vue?vue&type=template&id=4ecbe1bc&scoped=true&"
import script from "./CounterVisitor.vue?vue&type=script&lang=js&"
export * from "./CounterVisitor.vue?vue&type=script&lang=js&"
import style0 from "./CounterVisitor.vue?vue&type=style&index=0&id=4ecbe1bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecbe1bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
